module.exports = __webpack_public_path__ + "img/babys.4c98119c.svg";